
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import axios from "axios";
import {createApp} from "vue";
import veProgress from "vue-ellipse-progress";
import '@vuepic/vue-datepicker/dist/main.css';

/**
 * Identify every axios request as an XHR. Without this Laravel's StartSession middleware doesn't
 * recognize our api-internal fetches as AJAX (axios omits this header by default), so it records
 * them as the session's "previous URL" — which then poisons url()->previous()/back() links (e.g.
 * a page's Back button landing on an /api-internal/... endpoint). Setting it on the shared default
 * instance covers every `import axios from "axios"` across the app.
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const app = createApp({
    data() {
        return {
            permissions: {},
            permissions_meta: {},
            features: {},
            features_meta: {},
            options: {},
            options_meta: {},
        }
    },
    methods: {
    }
})
app.use(veProgress, "ve-progress");
app.config.compilerOptions.whitespace = 'preserve';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

app.mount("#app")

window.tippy = require('tippy.js').default;